import { render, staticRenderFns } from "./MemoPage.vue?vue&type=template&id=07af691e&scoped=true"
import script from "./MemoPage.vue?vue&type=script&lang=js"
export * from "./MemoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af691e",
  null
  
)

export default component.exports